// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimingAPIModel
 */
export interface TimingAPIModel {
    /**
     * 
     * @type {Date}
     * @memberof TimingAPIModel
     */
    nextAllowedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimingAPIModel
     */
    expiresAt: Date;
}

export function TimingAPIModelFromJSON(json: any): TimingAPIModel {
    return TimingAPIModelFromJSONTyped(json, false);
}

export function TimingAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimingAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextAllowedAt': (new Date(json['nextAllowedAt'])),
        'expiresAt': (new Date(json['expiresAt'])),
    };
}

export function TimingAPIModelToJSON(value?: TimingAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextAllowedAt': (value.nextAllowedAt.toISOString()),
        'expiresAt': (value.expiresAt.toISOString()),
    };
}


